export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
      badge: {
        variant: "primary",
        text: "HOME"
      }
    },
    {
      name: "Map Overview",
      url: "/base/Map",
      icon: "icon-map"
    },
    {
      name: "Overall Data",
      url: "/base/overall",
      icon: "icon-layers"
    },
    {
      name: "Backlog By Location",
      url: "/base/backlog-by-location",
      icon: "icon-layers"
    },
    {
      title: true,
      name: "TECHNICAL STATISTICS",
      class: "",
      wrapper: {
        element: "",
        attributes: {}
      }
    },
    {
      name: "Active Backlog",
      url: "/activeBacklog",
      icon: "icon-chart"
    },
    {
      name: "Analytics By Model",
      url: "/analyticsByModel",
      icon: "icon-chart"
    },
    {
      name: "Received Equipment",
      url: "/ReceivedEquipment",
      icon: "icon-chart"
    },
    {
      name: "Beyond Economical Repair",
      url: "/base/BER",
      icon: "icon-chart"
    },
    {
      name: "End Of Life",
      url: "/base/EOL",
      icon: "icon-chart"
    },
    {
      name: "Under Warranty",
      url: "/base/WAR",
      icon: "icon-chart"
    },
    {
      name: "Projects",
      url: "/base/projects",
      icon: "icon-chart"
    }
  ]
};
